import { useUser } from '@cast/infrastructure-auth';
import { IS_PROD_US } from '@cast/constants';
import { useHubspotContact } from 'core/hubspot';
import {
  useCreateFullHubspotContactMutation,
  useCreateHubspotContactMutation,
} from 'hooks/mutations/marketing';
import { usePersistentState } from '@cast/utils';

import { useIsContactsFormActive } from './useIsContactsFormActive';

export const useContactsForm = () => {
  const user = useUser();
  const { contactState } = useHubspotContact();
  const isContactsFormActive = useIsContactsFormActive();
  const [showForm, setShowForm] = usePersistentState(
    `phone-form-${user?.id}`,
    IS_PROD_US && user?.firstLogin && contactState === 'pending'
  );

  const { success } = useCreateHubspotContactMutation({
    pageName: 'Signup form - initial',
  });

  const { mutate: submitContactsForm } = useCreateFullHubspotContactMutation({
    pageName: 'Signup form - full',
    enabled: success && IS_PROD_US,
  });

  const closeContactsForm = () => {
    setShowForm(false);
  };

  return {
    submitContactsForm,
    showForm: showForm && success && isContactsFormActive,
    closeContactsForm,
  };
};
